import React from "react"
import modalStyles from "./modal.module.scss"
import { Link } from "gatsby"

const DashboardModal = ({ toggleDashboardModal }) => {
  return (
    <>
      <div className={modalStyles.dashboardModal}>
        <h1>Hey! Have you seen our dashboard?</h1>
        <p>
          You can have a website & mobile app build for you today for as little as $40 a month
        </p>
        <Link to="/purchase/">
          <button className="btn">Purchase today</button>
        </Link>
        <button className="btn--outlined" onClick={toggleDashboardModal}>
          Close
        </button>
      </div>

      <div className={modalStyles.overlay}></div>
    </>
  )
}

export default DashboardModal
